/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import GooglePlayBadge from "../images/google-play-badge.png"
import AppStoreBadge from "../images/app-store-badge.png"
import Top1 from "../images/top1.jpeg"
import Top2 from "../images/top2.jpeg"
import Top3 from "../images/top3.jpeg"
import "./layout.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} /> 
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `0 1.0875rem 1.45rem`,
          textAlign: `center`
        }}
      >
        <a href="https://play.google.com/store/apps/details?id=work.ymizushi.motonenpi&utm_source=webpage"><img src={ Top1 } alt="top1" /><img src={ GooglePlayBadge } alt="google-play-badge" /></a>
        <a href="https://itunes.apple.com/jp/app/id1582830881?mt=8"><img width="140px" src={ AppStoreBadge } alt="app-store-badge" /></a>
        
      </div>
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `0 1.0875rem 1.45rem`,
        }}
      >
        <img src={ Top2 } alt="top2" />
        <img src={ Top3 } alt="top3" />
        <main>{children}</main>
        <footer
          style={{
            marginTop: `2rem`,
            textAlign: `center`
          }}
        >
          © {new Date().getFullYear()}, ymizushi
        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
